import { Controller } from "react-hook-form";

import TextField from "@mui/material/TextField";

const ControlledTextField = ({
	control,
	defaultValue,
	name,
	label,
	error,
	errorMessage,
	shrinkLabel = true,
	startAdornment,
	endAdornment,
	variant = "outlined",
	inputProps,
	InputLabelProps,
	slotProps: providedSlotProps,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue && defaultValue}
			render={({ field: { onChange, value } }) => (
				<TextField
					size="small"
					name={name}
					value={value}
					label={label}
					variant={variant}
					fullWidth
					onChange={onChange}
					error={error}
					helperText={errorMessage ? errorMessage : ""}
					{...rest}
					slotProps={{
						...providedSlotProps,
						input: {
							...providedSlotProps?.input,
							startAdornment: startAdornment,
							endAdornment: endAdornment,
						},
						htmlInput: {
							...providedSlotProps?.htmlInput,
							...inputProps,
						},
						inputLabel: {
							...providedSlotProps?.inputLabel,
							...(InputLabelProps ||
								(shrinkLabel ? { shrink: shrinkLabel } : {})),
						},
					}}
				/>
			)}
		></Controller>
	);
};

export default ControlledTextField;
